import { useSelector } from "react-redux"
import PageGridAlt from "../Components/PageGridAlt";

const Watchlist = ()=>{
    const movies = useSelector(state=>state.WatchlistReducer);
    return <div className=" dark:bg-secondary-dark min-h-screen">
        <PageGridAlt data={movies}/>
    </div>
}

export default Watchlist